export var FlowRunCostDataSource;
(function (FlowRunCostDataSource) {
    FlowRunCostDataSource["Actual"] = "Actual";
    FlowRunCostDataSource["Estimated"] = "Estimated";
})(FlowRunCostDataSource || (FlowRunCostDataSource = {}));
//# sourceMappingURL=costDataSource.js.map